export interface SyncLog {
  id: number;
  partitionKey: string;
  rowKey: string;
  subscriptionId: string;
  companyId: number;
  requestedAt: string;
  requestedBy: string;
  startedAt: string;
  runStatus: string;
  hasError: boolean;
  errorMessage: string;
  isFullSync: boolean;
  jobRunId: string;
  tryCount: number;
  companyName: string;
  hasAnyError: string;
  forceSyncDate: string;
  statusId: number;
  status: string;
}

export interface SyncLogDetails {
  id: number;
  logId: number;
  partitionKey: string;
  rowKey: string;
  logPartitionKey: string;
  logRowKey: string;
  entity: string;
  startedAt: string;
  completedAt: string;
  runStatus: string;
  hasError: boolean;
  errorMessage: string;
  hasAnyError: string;
  syncFromDate: string;
  runStatusId: number;
  sourceSystem: string | null;
}
export interface SyncLogGetResponse {
  result: Property;
  errorMessage: any;
  timeGenerated: string;
}
export interface NetvisorMasterSyncLogGetResponse {
  status: string;
  statusCode: number;
  message: string;
  data: Property;
  error: any;
  timestamp: string;
  recordCount: number;
}
export interface NetvisorDetailsSyncLogGetResponse {
  status: string;
  statusCode: number;
  message: string;
  data: PropertySyncLogDetails;
  error: any;
  timestamp: string;
  recordCount: number;
}

export interface SyncLogDetailsGetResponse {
  result: PropertySyncLogDetails;
  errorMessage: any;
  timeGenerated: string;
}

export interface Property {
  result: SyncLog[];
  count: number;
}

export interface PropertySyncLogDetails {
  result: SyncLogDetails[];
  count: number;
}

export const RunStatus = {
  Pending: 1,
  Running: 2,
  Completed: 3,
  Failed: 4,
};
export interface AzureJobStatusDetails {
  name: string;
  instanceId: string;
  runtimeStatus: string;
  input: Input;
  createdTime: string;
  lastUpdatedTime: string;
}
export interface Input {
  subscriptionId: string;
  partitionKey: string;
  rowKey: string;
  forceSync: boolean;
}

export enum ModalType {
  requestedModal = "requestedModal",
  jobRunStatusModal = "jobRunStatusModal",
}

export interface FinanceMasterSyncLogGetResponse {
  status: string;
  statusCode: number;
  message: string;
  data: Property;
  error: any;
  timestamp: string;
  recordCount: number;
}
export interface FinanceDetailsSyncLogGetResponse {
  status: string;
  statusCode: number;
  message: string;
  data: PropertySyncLogDetails;
  error: any;
  timestamp: string;
  recordCount: number;
}